import styled from 'styled-components'

import { media } from 'src/styles/media'

export const QUESTION_HEIGHT_DESKTOP = 57.5

export const CardsWrap = styled.div`
  width: 100vw;
  height: 100%;
  position: relative;

  ${media.desktop} {
    width: 37.5rem;
    max-height: ${QUESTION_HEIGHT_DESKTOP}rem;
    min-height: 38rem;
    height: 100%;
    margin: auto;
    border-radius: 1.6rem;
    margin-top: 6rem;
    margin-bottom: 3rem;
    flex-shrink: 10;
  }
`

export const PullToBottom = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 3rem;

  @media (max-height: 650px) {
    display: none;
  }
`
